import React, { useEffect, useState } from "react";
import { ArrowRight, Sparkles } from "lucide-react";

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll effect for hero image
  const getHeroImageStyles = () => {
    const fadeStart = 0;
    const fadeEnd = 400;
    
    let opacity = 1;
    let transform = 'translateY(0px)';
    
    if (scrollY > fadeStart && scrollY <= fadeEnd) {
      const fadeProgress = scrollY / fadeEnd;
      opacity = 1 - (fadeProgress * 0.3); // Fade to 0.7 opacity
      transform = `translateY(${fadeProgress * 15}px)`; // Subtle parallax
    } else if (scrollY > fadeEnd) {
      opacity = 0.7;
      transform = 'translateY(15px)';
    }
    
    return { opacity, transform };
  };

  const heroImageStyles = getHeroImageStyles();

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <Sparkles className="hero-badge-icon" />
            <span>Aprender es una aventura</span>
          </div>
          
          <h1 className="hero-title">
            Tu hijo merece aprender en un lugar donde 
            <span className="hero-title-highlight"> la curiosidad se convierta en superpoder </span>
          </h1>
          
          <p className="hero-subtitle">
            Entrenamos a tus hijos en habilidades que las escuelas no enseñan:
            pensamiento crítico, competencias digitales y creatividad, a través de 
            clases divertidas, personalizadas y diseñadas para que aprendan con confianza.
          </p>
          
          <div className="hero-cta">
           <a
                href="https://wa.me/525572269158"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary-large"
                >
                  <span>Agenda una clase prueba </span>
                  <ArrowRight className="btn-icon" />
                </a>

            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">38+</span>
                <span className="stat-label">Estudiantes activos</span>
              </div>
              <div className="stat">
                <span className="stat-number">95%</span>
                <span className="stat-label">Satisfacción parental</span>
              </div>
            </div>
          </div>
        </div>
        
        <div 
          className="hero-visual"
          style={{
            opacity: heroImageStyles.opacity,
            transform: heroImageStyles.transform,
            transition: 'opacity 0.6s ease-out, transform 0.6s ease-out'
          }}
        >
          <div className="hero-image-container">
            <img 
              src="https://images.unsplash.com/photo-1536148935331-408321065b18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxraWRzJTIwY29kaW5nfGVufDB8fHx8fDE3NTgwNzM1NjB8MA&ixlib=rb-4.1.0&q=85"
              alt="Kids creating digital worlds"
              className="hero-image"
            />
            <div className="hero-glow"></div>
          </div>
          
          <div className="floating-elements">
            <div className="floating-element element-1"></div>
            <div className="floating-element element-2"></div>
            <div className="floating-element element-3"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;